import { render, staticRenderFns } from "./PurchaseInvoices.vue?vue&type=template&id=2c07a9de&scoped=true&"
import script from "./PurchaseInvoices.vue?vue&type=script&lang=js&"
export * from "./PurchaseInvoices.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseInvoices.vue?vue&type=style&index=0&id=2c07a9de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c07a9de",
  null
  
)

export default component.exports